import { render } from "./SvgMapWithPopup.vue?vue&type=template&id=52db213e&scoped=true"
import script from "./SvgMapWithPopup.vue?vue&type=script&lang=js"
export * from "./SvgMapWithPopup.vue?vue&type=script&lang=js"

import "./SvgMapWithPopup.vue?vue&type=style&index=0&id=52db213e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52db213e"]])

export default __exports__